import { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './AdditionalInfoLayout.module.css';

interface AdditionalInfoLayoutProps {
	children?: ReactNode;
	title: string;
}

export const AdditionalInfoLayout: React.VFC<AdditionalInfoLayoutProps> = ({
	title,
	children,
}) => {
	return (
		<section
			className={classNames(styles.wrapper)}
			data-testid="AdditionalInfoLayout"
		>
			<div className={styles['title-column']}>
				<h1 className="fluid-font-t1">{title}</h1>
			</div>

			{children}
		</section>
	);
};
